// extracted by mini-css-extract-plugin
module.exports = {"tagsContainer":"tags_tagsContainer__1DSl5"};